export enum PricingMethod {
  VIEWS = "VIEWS",
  NONE = "NONE",
}

export const PricingMethodEnumMapping: Record<PricingMethod, string> = {
  [PricingMethod.VIEWS]: "enumMapping.paymentMethode.lowercase.VIEWS",
  [PricingMethod.NONE]: "enumMapping.paymentMethode.lowercase.NONE",
};

export interface PricingMethodInterface {
  id: PricingMethod;
  value: string;
}
